export const loadText = text => {
  const loaderContainer = document.querySelector('.loader-text')
  const textElement = document.createElement('div')
  textElement.innerHTML = text
  loaderContainer.append(textElement)
}
